module.exports = {
        ServerIOOverrides: {
        	MEASURE_ENDPOINT: `https://measure.good-loop.com/measure`
        }
};
